
import Room from './Room';
import Library from '../utility/Library';

// Function to generate a floor map
/*const REWARD_CHANCES = [
    normal: [
        { type: 'shards', chance: 0.32 },
        { type: 'runes', chance: 0.32 },
        { type: 'seed', chance: 0.12 },
        { type: 'coin', chance: 0.12 },
        { type: 'berry', chance: 0.12 }
    ],
    hard: [
        { type: 'relic', chance: 0.2 },
        { type: 'shards', chance: 0.3 },
        { type: 'runes', chance: 0.3 },
        { type: 'remove', chance: 0.2 }
    ]
        { type: 'remove', chance: 0.25 },
        { type: 'seed', chance: 0.25 },
        { type: 'coin', chance: 0.25 },
        { type: 'berry', chance: 0.25 }
];*/

const REWARD_CHANCES = {
	1: {
		card: 0.25,
		seed: 0.25,
		coin: 0.25,
		berry: 0.25
	},
	2: {
		card: 0.23,
		seed: 0.23,
		coin: 0.23,
		berry: 0.23,
		paws: 0.08
	}
}

function rewardChancesForPower(power) {
	return REWARD_CHANCES[power > 1 ? 2 : 1];
}

const EVENT_CHEST_CHANCE = 0.08;
const EVENT_FIGHT_CHANCE = 0.15;
const EVENT_FOUNTAIN_CHANCE = 0.02;
const EVENT_SHOP_CHANCE = 0.03;
const EVENT_TREASURE_CHANCE = 0.02;

function chooseReward(difficulty, usedRewards) {
	return pickAtRandom(REWARD_CHANCES[1]);
    const rewards = REWARD_CHANCES[difficulty];
    let reward;

    do {
        const roll = Math.random();
        let cumulative = 0;

        for (const r of rewards) {
            cumulative += r.chance;
            if (roll < cumulative) {
                reward = r;
                break;
            }
        }
    } while (!reward.multiple && usedRewards.includes(reward.type));

    return reward.type;
}

function generatePaths() {
  const HEIGHT = 16;
  const WIDTH = 7;
  const PATH_COUNT = 5;

  const possibleRooms = [
    [0, 0, 0, 1, 0, 0, 0], // L1
    [0, 0, 1, 1, 1, 0, 0], // L2
    [0, 1, 1, 1, 1, 1, 0], // L3
    [1, 1, 1, 1, 1, 1, 1], // L4
    [1, 1, 1, 1, 1, 1, 1], // L5
    [1, 1, 1, 1, 1, 1, 1], // L6
    [1, 1, 1, 1, 1, 1, 1], // L7
    [0, 1, 0, 1, 0, 1, 0], // L8
    [0, 1, 0, 1, 0, 1, 0], // L8
    [1, 1, 1, 1, 1, 1, 1], // L9
    [1, 1, 1, 1, 1, 1, 1], // L10
    [1, 1, 1, 1, 1, 1, 1], // L11
    [1, 1, 1, 1, 1, 1, 1], // L12
    [0, 1, 1, 1, 1, 1, 0], // L13
    [0, 0, 1, 1, 1, 0, 0], // L14
    [0, 0, 0, 1, 0, 0, 0], // L15
  ];

  const map = Array.from({ length: HEIGHT }, (_, y) =>
    Array.from({ length: WIDTH }, (_, x) =>
      possibleRooms[y][x] ? { next: [] } : null
    )
  );

  function isValid(y, x) {
    return y >= 0 && y < HEIGHT && x >= 0 && x < WIDTH && map[y][x];
  }

  const startX = 3;
  const connectionMap = Array.from({ length: HEIGHT - 1 }, () => []); // store [fromX, toX] for each layer

  for (let i = 0; i < PATH_COUNT; i++) {
    let y = 0, x = startX;

    while (y < HEIGHT - 1) {
      const nextY = y + 1;

      const candidates = [-1, 0, 1]
        .map(d => x + d)
        .filter(nx => {
          if (!isValid(nextY, nx)) return false;

          // Disallow horizontal crossing with existing connections at this level
          for (const [fromX, toX] of connectionMap[y]) {
            if (
              (fromX < x && toX > nx) || // L→R crossing over R→L
              (fromX > x && toX < nx)    // R→L crossing over L→R
            ) {
              return false;
            }
          }

          return true;
        });

      if (candidates.length === 0) break;

      const nextX = candidates[Math.floor(Math.random() * candidates.length)];

      map[y][x].next.push(nextX);
      connectionMap[y].push([x, nextX]);

      y = nextY;
      x = nextX;
    }
  }

  map.push([null,null,null,{next:[]},null,null,null]);
  map.forEach((layer,n) => layer.forEach((room,i) => {
  	if (!room)
  		return;
  	room.index = i;
  	room.next = [...new Set(room.next)]
  	if (room.next.length === 0 && n < 15)
  		layer[i] = null;
  	else if (n === 15)
  		room.next = [3];
  }))

  return map;
}

const ROOM_CHANCE = {
	normal: 0.7,
	rival: 0,
	event: 0.24,
	treasure: 0.0,
	shop: 0.06,
	celestial: 0.0
}

/*const ROOM_CHANCE = {
	normal: 0.46,
	hard: 0.26,
	event: 0.22,
	shop: 0.06
}*/

const MIDWAY_CHANCE = {
	treasure: 0.55,
	fountain: 0.45
}

function pickAtRandom(chances) {
	const rand = Math.random();
	let cumulative = 0;

	for (const [key, chance] of Object.entries(chances)) {
		cumulative += chance;
		if (rand < cumulative) {
			return key;
		}
	}
}

function addRooms(map, mazePower, firstfloor, run) {
	const rewardChances = rewardChancesForPower(mazePower);

	// Soul management
	/*if (soul && [0, 5, 11].includes(soul.room))
		soul = null; // Safeguard to prevent unplanned soul rooms
	if (soul) {
		let soulroom = map[soul.room].filter(r => r)[Math.floor(Math.random() * map[soul.room].filter(r => r).length)];
		if (soul.room === 12) {
			soulroom.type = "boss";
			soulroom.reward = "soul";
		} else
			soulroom.type = "soul";
	}*/

	let remainingCelestials = ["amaryllis", "nikara", "aurora", "zephyrus"];

	map.forEach((layer,i) => layer.forEach(room => {
	  	if (!room || room.type)
	  		return;
	  	if (i === 0)
	  		room.type = "start";
	  	else if (i === 1 && firstfloor) 
	  		room.type = "normal";
	  	else if (i === 7) 
	  		room.type = "treasure";
	  	else if (i === 8) 
	  		room.type = "fountain";
	  	else if (i === 14)
	  		room.type = "normal";
  		else if (i === 15)
  			room.type = "fountain";
  		else if (i === 16)
  			room.type = "boss";
	  	while (!room.type) {
	  		room.type = pickAtRandom(ROOM_CHANCE);
	  		if (room.type === "hard") {
	  			/*if (i === 4)
	  				room.type = Math.random() < 0.5 ? "hard" : "normal"; // Room 4 has lower hard fight chance
	  			else*/ if (i < 7)
	  				room.type = "normal"; // No hard fights before room 7
	  		}
	  		else if (room.type === "shop" || room.type === "menagerie") {
	  			if (firstfloor && i < 7)
	  				delete room.type; // Can't have a shop too early
	  			else if (map[i-1].some(previous => previous && previous.next.includes(room.index) && previous.type === room.type))
	  				delete room.type; // Can't have two consecutive shops
	  		}
	  	}
	}));

	let minshops = ["shop"];
	if (mazePower > 1)
		minshops.push("menagerie");
	minshops.forEach(type => {

		const ELIGIBLE_LAYERS = firstfloor ? [9, 10, 11, 12, 13] : [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 13];

		const hasType = ELIGIBLE_LAYERS.some(i =>
			map[i]?.some(room => room?.type === type)
		);

		if (!hasType) {
			const forbidden = type === "shop" ? ["shop"] : ["menagerie", "shop"];
			const candidates = ELIGIBLE_LAYERS.flatMap(i =>
				map[i]?.filter(room => room && !forbidden.includes(room.type)) || []
			);

			if (candidates.length) {
				const chosen = candidates[Math.floor(Math.random() * candidates.length)];
				chosen.type = type;
			}
		}
	});

	map.forEach((layer,i) => layer.forEach(room => {
		if (room && room.type === "celestial") {
			if (remainingCelestials.length > 0) {
			  const index = Math.floor(Math.random() * remainingCelestials.length);
			  room.type = remainingCelestials[index];
			  remainingCelestials.splice(index, 1);
			} else {
			  room.type = "normal";
			}
		}
		//if (room && room.type === "hard")
		//	room.type = "normal";
	}));

	// Assign fight rewards
	map.forEach((layer,i) => layer.forEach(room => {
	  	if (!room)
	  		return;
	  	if (room.type === "normal") {
	  		room.type = "fight";
	  		room.difficulty = firstfloor && i === 1 ? "easy" : "normal";
	  		room.reward = pickAtRandom(rewardChances);
	  		while (firstfloor && i === 1 && room.reward === "berry")
	  			room.reward = pickAtRandom(rewardChances); // No berry on the very first fight
	  		if (i > 7)
	  			room.difficulty = "hard";
	  	} else if (room.type === "hard") {
	  		room.type = "fight";
	  		room.difficulty = "hard";
	  		let hardchance = Math.random();
	  		if (hardchance < 0.25) // 25% chance for a hard fight to reward a relic
	  			room.reward = "relic";
	  		else if (mazePower > 1 && hardchance < 0.375) // 12.5% chance for a hard fight to reward a token
	  			room.reward = "paws";
	  		else {
	  		room.reward = [pickAtRandom(rewardChances), pickAtRandom(rewardChances)];
	  		while (room.reward[0] === room.reward[1])
	  			room.reward[1] = pickAtRandom(rewardChances);
	  		}
	  	} else if (room.type === "soul") {
	  		room.type = "fight";
	  		if (firstfloor && i === 1)
	  			room.difficulty = "easy";
	  		else if (i < 7)
	  			room.difficulty = "normal";
	  		else
	  			room.difficulty = "hard";
	  		room.reward = pickAtRandom(rewardChances);
	  	}
	}))
}

function generateFloorMap(floor, eventCount) {
    const roomTypes = ['fight', 'event', 'treasure', 'fountain', 'shop', 'menagerie'];

    // Initialize map with empty sections
    const mapLayout = Array.from({ length: 13 }, () => []);

    // Section 0: Starter
    mapLayout[0] = ['start'];

    // Section 12: Boss
    mapLayout[15] = ['boss'];

    // Section 11: Fountain
    mapLayout[14] = ['fountain'];

    // Section 1 and 10: All fights
    mapLayout[1] = ['fight', 'fight'] //Array.from({ length: Math.floor(Math.random() * 2) + 2 }, () => 'fight');
    mapLayout[13] = ['fight', 'fight'] //Array.from({ length: Math.floor(Math.random() * 2) + 2 }, () => 'fight');

    // Random section between 3 and 8: All fights
    const fightOnlySection = Math.floor(Math.random() * 9) + 3;
    mapLayout[fightOnlySection] = ['fight', 'fight'] //Array.from({ length: Math.floor(Math.random() * 2) + 2 }, () => 'fight');

    // Generate treasure between sections 4 and 9
    let treasureSection;
    do {
	    treasureSection = Math.floor(Math.random() * 7) + 6;
	} while (mapLayout[treasureSection].length >= 2);
    mapLayout[treasureSection] = ['treasure', ...mapLayout[treasureSection]];

    // Generate shops
    let shopSections = [];
    if (floor === 1) {
	    let shopSection;
	    do {
		    shopSection = Math.floor(Math.random() * 6) + 7;
		} while (mapLayout[shopSection].length >= 2 && !mapLayout[shopSection].some(room => room === "treasure"));
        shopSections = [shopSection];
    } else {
	    do {
	        shopSections = Array.from({ length: Math.random() < 0.75 ? 2 : 1 }, () => Math.floor(Math.random() * 12) + 1)
	            .filter((sec, idx, arr) => idx === 0 || Math.abs(sec - arr[idx - 1]) > 1);
		} while (shopSections.some(ss => mapLayout[ss].length >= 2 && !mapLayout[ss].some(room => room === "treasure")));
    }

    shopSections.forEach(section => {
        mapLayout[section] = ['shop', ...mapLayout[section]];
    });

    // Generate fountains
    /*let fountainSections = [];
    if (floor === 1) {
	    let fountainSection;
	    do {
		    fountainSection = Math.floor(Math.random() * 3) + 6;
		} while (mapLayout[fountainSection].length >= 2);
        fountainSections = [fountainSection];
    } else {
	    let fountainSection;
	    do {
		    fountainSection = Math.floor(Math.random() * 6) + 3;
		} while (mapLayout[fountainSection].length >= 2);
        fountainSections = [fountainSection];
    }

    fountainSections.forEach(section => {
        mapLayout[section] = ['fountain', ...mapLayout[section]];
    });*/

    // Fill remaining sections with fights and events
    for (let section = 2; section < 14; section++) {
        if (mapLayout[section].length === 0) {
            const roomCount = Math.floor(Math.random() * 2) + 2;
            mapLayout[section] = ['fight'];
            if (Math.random() < 0.34) {
                mapLayout[section].push('event');
            }
        } else if (mapLayout[section].length === 1 && !mapLayout[section].includes('fight')) {
            mapLayout[section].push('fight');
        }

        // Ensure only one event per section
        if (mapLayout[section].filter(room => room === 'event').length > 1) {
            mapLayout[section] = mapLayout[section].filter((room, index, self) => room !== 'event' || self.indexOf(room) === index);
        }
    }

    // Randomly place events, ensuring the correct count
    let eventSections = Array.from({ length: eventCount }, () => Math.floor(Math.random() * 11) + 2);
    eventSections = [...new Set(eventSections)]; // Ensure unique sections

    eventSections.slice(0, eventCount).forEach(section => {
        if (!mapLayout[section].includes('event') && section !== 14) {
            mapLayout[section].push('event');
        }
    });

    // Ensure room count consistency in sections
    for (let section = 1; section < 14; section++) {
        if (mapLayout[section].length > 3) {
            mapLayout[section] = mapLayout[section].slice(0, 3);
        } else if (mapLayout[section].length < 2) {
            mapLayout[section].push('fight');
        }
    }

    // Transform rooms into objects and assign difficulties and rewards for fights
    for (let section = 0; section < 16; section++) {
        const hardFightChance = Math.min(0.1 * (section - 1), 0.6); // Scale chance from 0% to 60%
        let hasHardFight = false;
        let usedRewards = [];

        mapLayout[section] = mapLayout[section].map(room => {
            if (room === 'fight') {
                const difficulty = (Math.random() < hardFightChance || (section === 13 && !hasHardFight)) ? 'hard' : 'normal';
                if (difficulty === 'hard') hasHardFight = true;

                const reward = chooseReward(difficulty, usedRewards);
                if (!REWARD_CHANCES.find(r => r.type === reward)?.multiple) {
                    usedRewards.push(reward);
                }

                return { type: 'fight', difficulty, reward };
            }
            return { type: room };
        });

        if (section < 7 && mapLayout[section].every(room => room.type === 'fight' && room.difficulty === 'hard')) {

        	let noRoomChange = Math.random() > 0.5 ? 0 : 1;
            mapLayout[section][noRoomChange] = { type: 'fight', difficulty: 'normal', reward: chooseReward('normal', [mapLayout[section][1-noRoomChange].reward]) };
        }
    }

    if (floor === 1)
    	mapLayout[1].forEach(room => {
    		room.difficulty = "easy";
    		while (room.reward === "berry" || mapLayout[1][0].reward === mapLayout[1][1].reward)
    			room.reward = Math.random() < 0.5 ? "seed" : "coin";
    	});

    const relicObjects = [];
    // Collect all relic instances
	mapLayout.flat().forEach(obj => {
	if (obj.reward === "relic") {
		  relicObjects.push(obj);
		}
	});

	// If there's more than one, keep one at random
	if (relicObjects.length > 1) {
		const keepIndex = Math.floor(Math.random() * relicObjects.length);
		relicObjects.forEach((obj, index) => {
		  if (index !== keepIndex) obj.reward = "remove";
		});
	}

    // Shuffle rooms within sections
    for (let section = 1; section < 14; section++) {
        mapLayout[section] = mapLayout[section].sort(() => Math.random() - 0.5);
    }

    return mapLayout;
}

export default class Map {

	constructor (run) {

		this.run = run;
	}

	get rooms () {

		return this.grid.flatMap(row => row.filter(value => value !== undefined && value !== null));
	}

	pickEvent (type) {

		let events = Object.values(Library.getEvents(this.run.power));
		let possibilities = events.filter(r => r.type === type && Library.eventAvailableForRun(r, this.run))
		let randomIndex = Math.floor(Math.random() * possibilities.length);
		let event = possibilities[randomIndex];
		return event;
	}

	generate () {

		this.sections = generatePaths();
		addRooms(this.sections, this.run.power, this.run.floor === 1, this.run)
		//this.sections = generateFloorMap(this.run.floor, 0);

		let events = Object.values(Library.getEvents(this.run.power));
		events = events.filter(r => r.type === "event" && !r.conditional && Library.eventAvailableForRun(r, this.run));	
		let remainingevents = events.slice();

		for (let i = 0; i < this.sections.length; i++) {
			for (let j = 0; j < this.sections[i].length; j++) {
				let model = this.sections[i][j];
				if (!model)
					continue;
				switch (model.type) {
				case "event":
					/*const event_type_random = Math.random();
					if (event_type_random < EVENT_CHEST_CHANCE)
						Object.assign(model, { type: 'event', becomes: 'chest' })
					else if (event_type_random < EVENT_CHEST_CHANCE + EVENT_FIGHT_CHANCE) {
						const hardFightChance = i <= 4 ? 0 : (i-4) / 10;
						const difficulty = Math.random() < hardFightChance ? "hard" : "normal";
						const reward = chooseReward(difficulty, []);
		                Object.assign(model, { type: 'event', becomes: 'fight', difficulty, reward });
					} else if (event_type_random < EVENT_CHEST_CHANCE + EVENT_FIGHT_CHANCE + EVENT_SHOP_CHANCE) {
						Object.assign(model, this.pickEvent("shop"), { type: 'event', becomes: 'shop' });
					} else if (event_type_random < EVENT_CHEST_CHANCE + EVENT_FIGHT_CHANCE + EVENT_SHOP_CHANCE + EVENT_FOUNTAIN_CHANCE) {
						Object.assign(model, { type: 'event', becomes: 'fountain' })
					} else if (event_type_random < EVENT_CHEST_CHANCE + EVENT_FIGHT_CHANCE + EVENT_SHOP_CHANCE + EVENT_FOUNTAIN_CHANCE + EVENT_TREASURE_CHANCE) {
						Object.assign(model, { type: 'event', becomes: 'treasure' })
					} else {
						if (remainingevents.length === 0)
							remainingevents = events.slice();
						let randomIndex = Math.floor(Math.random() * remainingevents.length);
						Object.assign(model, remainingevents[randomIndex]);
						remainingevents.splice(randomIndex, 1);
					}*/
					break;
				case "shop":
					Object.assign(model, this.pickEvent("shop"));
					break;
				case "menagerie":
					Object.assign(model, this.pickEvent("menagerie"));
					break;
				default: break; 
				}
				this.sections[i][j] = model;
			}
		}

		/*for (let i = 0; i < this.grid.length; i++) {
			for (let j = 0; j < this.grid[i].length; j++) {
				if (!this.grid[i][j])
					continue;
				let type = this.grid[i][j].type;
				switch (type) {
					case "treasure":
					case "fountain":
					case "event":
					case "start":
					case "boss":
						this.grid[i][j] = new Room(this.run, j, i, this.grid[i][j]);
						break;
					case "normal": {
						let model = null;
						let randomRoomType = Math.random() * nbmainrooms;
						if (randomRoomType < nbfights) {
							model = { type: "fight" }
							nbfights--;
						} else if (randomRoomType < nbfights + nbchestrooms) {
							model = { type: "chest" }
							nbchestrooms--;
						} else if (randomRoomType < nbfights + nbchestrooms + nbeventrooms) {
							if (remainingevents.length === 0)
								remainingevents = events.slice();
							let randomIndex = Math.floor(Math.random() * remainingevents.length);
							model = remainingevents[randomIndex];
							remainingevents.splice(randomIndex, 1);
							nbeventrooms--;
						} else {
							model = { type: "empty" }
							nbemptyrooms--;
						}
						this.grid[i][j] = new Room(this.run, j, i, model);
						nbmainrooms--;
						break;
					}
					case "shop":
						this.grid[i][j] = new Room(this.run, j, i, this.pickEvent("shop"));
						break;
					default: break;
				}
			}
		}*/


		/*let str = "";
		map.forEach(c => {
			c.forEach(t => {
				if (t)
				switch (t.type) {
					case "treasure": str += "T"; break;
					case "shop": str += "$"; break;
					case "fountain": str += "F"; break;
					case "event": str += "?"; break;
					case "normal": str += "."; break;
					case "start": str += "O"; break;
					case "boss": str += "X"; break;
					default: str += " "; break;
				}
				else str += " "
			})
			str += "\n";
		})*/
	}

	get start () {

		return this.sections[0][3];
	}

	serialize () {

		return {
			sections: this.sections.map(s => s.slice())
		}
	}

	static build (run, src) {

		let map = new Map(run);
		if (src.sections)
			map.sections = src.sections.map(s => s.slice());
		return map;
	}
}
